<div class="RequestedItemsMainContent">
  <!-- Page Header -->
  <div class="PageHeader">
    <div class="PageTitle">
      <i class="material-icons">request_quote</i>
      <span>{{ 'RequestedIndividualItems' | translate }}</span>
    </div>
    <div class="PageTitle PageTitleRight">
      <span>{{ Items.length }} {{ 'ItemsFound' | translate }}</span>
    </div>
    <div style="clear: both;"></div>
  </div>

  <!-- Filter Bar -->
  <div class="FilterBar">
    <!-- Period Dropdown -->
    <div class="PeriodSearchContainer" *ngIf="MasterData?.Periods?.length > 0">
      <div class="PeriodOverlayTransparent" *ngIf="showPeriodDropdown" (click)="showPeriodDropdown = false"></div>
      <div class="PeriodSearchBar" (click)="onPeriodDropdownFocus()">
        <i class="material-icons period-icon">date_range</i>
        <input type="text" class="PeriodSearchInput" [value]="getPeriodLabel()" [placeholder]="'Receptions.ChoosePeriod' | translate" readonly />
        <i class="material-icons period-clear" *ngIf="Filter.Period?.ID" (click)="clearPeriodFilter(); $event.stopPropagation();">close</i>
        <i class="material-icons dropdown-icon">arrow_drop_down</i>
      </div>
      <div class="PeriodSearchResults" *ngIf="showPeriodDropdown">
        <div class="PeriodSearchResult" *ngFor="let p of MasterData.Periods" (click)="selectPeriod(p)">
          <span>{{ p.Name }}</span>
          <i class="material-icons" *ngIf="Filter.Period?.ID === p.ID">check</i>
        </div>
      </div>
    </div>

    <!-- From Date -->
    <mat-form-field class="CompactField" appearance="outline">
      <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="dp" [formControl]="FromDate" (dateChange)="ClearPeriod()">
      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
      <mat-datepicker #dp></mat-datepicker>
    </mat-form-field>

    <!-- To Date -->
    <mat-form-field class="CompactField" appearance="outline">
      <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="dp1" [formControl]="ToDate" (dateChange)="ClearPeriod()">
      <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
      <mat-datepicker #dp1></mat-datepicker>
    </mat-form-field>

    <!-- Status Dropdown -->
    <div class="StatusSearchContainer" *ngIf="MasterData?.OfferRequestStatuses?.length > 0">
      <div class="StatusOverlayTransparent" *ngIf="showStatusDropdown" (click)="showStatusDropdown = false"></div>
      <div class="StatusSearchBar" (click)="onStatusDropdownFocus()">
        <i class="material-icons status-icon">flag</i>
        <input type="text" class="StatusSearchInput" [value]="Filter.IndividualStatus?.Name || ''" [placeholder]="'Status' | translate" readonly />
        <i class="material-icons status-clear" *ngIf="Filter.IndividualStatus?.ID" (click)="clearStatusFilter(); $event.stopPropagation();">close</i>
        <i class="material-icons dropdown-icon">arrow_drop_down</i>
      </div>
      <div class="StatusSearchResults" *ngIf="showStatusDropdown">
        <div class="StatusSearchResult" *ngFor="let s of MasterData.OfferRequestStatuses" (click)="selectStatusFilter(s)">
          <span>{{ s.Name }}</span>
          <i class="material-icons" *ngIf="Filter.IndividualStatus?.ID === s.ID">check</i>
        </div>
      </div>
    </div>

    <!-- Search -->
    <div class="SearchContainer">
      <i class="material-icons search-icon">search</i>
      <input type="text" class="SearchInput" [placeholder]="'Search' | translate" [(ngModel)]="Filter.SearchTerm" (ngModelChange)="searchTermUpdate.next($event)">
      <i class="material-icons clear-icon" *ngIf="Filter.SearchTerm" (click)="Filter.SearchTerm = ''; applyFilter();">close</i>
    </div>

    <!-- Apply Filter Button -->
    <button class="GridCommandButton" (click)="applyFilter()">
      <i class="material-icons">filter_alt</i>
      <span>{{ 'Filter' | translate }}</span>
    </button>

    <!-- Reset Filter Button -->
    <button class="GridCommandButton GridCommandButtonClear" (click)="resetFilter()">
      <i class="material-icons">refresh</i>
      <span>{{ 'Reset' | translate }}</span>
    </button>
  </div>

  <!-- Loading State -->
  <div class="LoadingState" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
    <span>{{ 'Loading' | translate }}...</span>
  </div>

  <!-- Error State -->
  <div class="ErrorState" *ngIf="errorMessage && !isLoading">
    <i class="material-icons">error_outline</i>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- Empty State -->
  <div class="EmptyState" *ngIf="!isLoading && !errorMessage && Items.length === 0">
    <i class="material-icons">inbox</i>
    <p>{{ 'NoItemsFound' | translate }}</p>
  </div>

  <!-- AG Grid Style Table -->
  <div class="GridContainer" *ngIf="!isLoading && !errorMessage && Items.length > 0">
    <!-- Grid Header -->
    <div class="GridHeader">
      <div class="GridCell col-index">#</div>
      <div class="GridCell col-brand">{{ 'Brand' | translate }}</div>
      <div class="GridCell col-partnumber">{{ 'PartNumber' | translate }}</div>
      <div class="GridCell col-name">{{ 'ProductName' | translate }}</div>
      <div class="GridCell col-qty">{{ 'Quantity' | translate }}</div>
      <div class="GridCell col-price">{{ 'Price' | translate }}</div>
      <div class="GridCell col-currency">{{ 'Curr' | translate }}</div>
      <div class="GridCell col-total">{{ 'Total' | translate }}</div>
      <div class="GridCell col-eta">{{ 'ETA' | translate }}</div>
      <div class="GridCell col-status">{{ 'Status' | translate }}</div>
      <div class="GridCell col-date">{{ 'Date' | translate }}</div>
    </div>

    <!-- Grid Body -->
    <div class="GridBody">
      <div class="GridRow" *ngFor="let item of Items"
           [class.status-pending]="item.statusID === 0"
           [class.status-completed]="item.statusID === 1">
        <div class="GridCell col-index">{{ item.index }}</div>
        <div class="GridCell col-brand">{{ item.brand }}</div>
        <div class="GridCell col-partnumber">{{ item.partNumber }}</div>
        <div class="GridCell col-name">{{ item.name }}</div>
        <div class="GridCell col-qty">{{ item.quantity }}</div>
        <div class="GridCell col-price">{{ item.price }}</div>
        <div class="GridCell col-currency">{{ item.currency }}</div>
        <div class="GridCell col-total">{{ item.total }}</div>
        <div class="GridCell col-eta">{{ item.eta }}</div>
        <div class="GridCell col-status">
          <span class="StatusBadge"
                [class.status-0]="item.statusID === 0"
                [class.status-1]="item.statusID === 1"
                [class.status-2]="item.statusID === 2"
                [class.status-3]="item.statusID === 3"
                [class.status-4]="item.statusID === 4"
                [class.status-default]="item.statusID > 4 || item.statusID < 0">
            {{ item.status }}
          </span>
        </div>
        <div class="GridCell col-date">{{ formatDate(item.CreatedDate) }}</div>
      </div>
    </div>
  </div>
</div>
